import axiosInstance from './api';

export const getWingmanMetrics = async (params = {}) => {
  try {
    const response = await axiosInstance.get('/admin/wingman-metrics', { params });
    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      message: error.message || 'Failed to fetch wingman metrics',
      error,
    };
  }
};
